module.exports = __webpack_public_path__ + "img/20210906-1630898427903750.6e25932f.jpg";